<!-- Loading Overlay -->
<div class="loading-overlay" *ngIf="showLoader">
    <cv-loader></cv-loader>
</div>

<sol-modal (dismissed)="onCancelClicked()" [title]="cvLocalizationService.getCachedText('Dashboard_Access', 'Share_Dashboard', 'Share Dashboard')">
    <sol-modal-body>
        <!-- Body -->
        <div class="pt-3 pb-3" [ngClass]="selection === custom ? 'share-custom-body' : 'share-body'">
        <!-- Slide Toggle -->
        <div class="bodyRow d-flex align-items-center">
            <sol-slide-toggle ngbAutoFocus [size]="'small'" [(ngModel)]="shareDashboard" (checkedChange)="checkSelection()">
                <span class="mt-1" cvLocalizedText langSection="Dashboard_Access" langKey="Share_Dashboard">Share Dashboard</span>
            </sol-slide-toggle>        
        </div>
        <!-- Radio Buttons -->
        <div class="bodyRow mt-3 d-flex" *ngIf="shareDashboard">
            <sol-radio-group [(ngModel)]="selection" [inline]="true">
                <sol-radio-button type="radio"
                                    [value]="allEmployees">
                    {{cvLocalizationService.getCachedText('Dashboard_Access', 'All_Employees', 'All Employees')}}
                </sol-radio-button>
                <sol-radio-button type="radio"
                                    [value]="custom">
                    {{cvLocalizationService.getCachedText('Dashboard_Access', 'Custom', 'Custom')}}
                </sol-radio-button>
            </sol-radio-group>
        </div>

        <div [hidden]="selection !== custom" class="bodyRow mt-3 bg-white">

            <sol-tabs [size]="'large'" [selectedIndex]="activeTabIndex" (selectedTabChange)="onTabChange($event)">
                <!-- Teams Tab -->
                <sol-tab [titleTemplate]="teamsTitle" #teamsTab [isActive]="true">
                    <div>
                        <div class="d-flex justify-content-between mb-2 mt-3">
                            <sol-dropdown
                                *ngIf="initialized && isTeamsLoaded && activeTabIndex === 0"
                                class="list-dropdown ml-4"
                                id="share-modal-teams"
                                [(ngModel)]="checkedTeams"
                                placeholder="{{cvLocalizationService.getCachedText('Dashboard_Access', 'Select_Teams', 'Select teams')}}"
                                [isMultiple]="true"
                                [options]="filteredTeams"
                                [optionsLabel]="'GroupName'"
                                [optionsValue]="'GroupID'"
                                [searchEnabled]="true"
                                (dropdownOpenStateChange)="checkSelectedTeamsList($event)"
                                (searchChanged)="onSearchTeamsChange($event)">
                            </sol-dropdown>
                            <sol-button class="ml-auto mr-4" 
                                        (click)="removeTeamPermissions()" 
                                        [variant]="'text'"
                                        [disabled]="selectedTeamsList.size === 0">
                                <span cvLocalizedText langSection="Dashboard_Access" langKey="Remove">Remove All</span>
                            </sol-button>
                        </div>
                        <div [hidden]="selectedTeamsList.size === 0">
                            <!-- Search -->
                            <sol-text-input [type]="'search'"
                                            autocomplete="off"
                                            [placeholder]="teamSearchLocal"
                                            [(ngModel)]="teamFilterValue"
                                            (ngModelChangeDebounced)="applyTeamFilter()"
                                            [ngModelChangeDebounceTime]="500"
                                            ng-trim="true">
                            </sol-text-input>
                        </div>
                        <div>
                            <!-- Teams AG Grid -->
                            <ag-grid-angular 
                                #dashboardAccessTeamGrid
                                *ngIf="teamGridOptions !== null && activeTabIndex === 0 && selection === custom" 
                                class="ag-theme-balham flex-fill inner" 
                                [ngClass]="selectedTeams.length === 0 ? 'ag-grid-no-search' : 'ag-grid-search'"
                                [gridOptions]="teamGridOptions"
                                [rowHeight]="44">
                            </ag-grid-angular>
                        </div>
                    </div>
                </sol-tab>
                <!-- Employees Tab -->
                <sol-tab [titleTemplate]="employeesTitle" #employeesTab>
                    <div>
                        <div class="d-flex justify-content-between mb-2 mt-3">
                            <sol-dropdown
                                *ngIf="initialized && isEmpsLoaded && activeTabIndex === 1"
                                class="list-dropdown ml-4"
                                id="share-modal-employees"
                                [(ngModel)]="checkedEmployees"
                                placeholder="{{cvLocalizationService.getCachedText('Dashboard_Access', 'Select_Employees', 'Select employees')}}"
                                [isMultiple]="true"
                                [options]="filteredEmps"
                                [optionsLabel]="'FullName'"
                                [optionsValue]="'LoginID'"
                                [searchEnabled]="true"
                                (dropdownOpenStateChange)="checkSelectedEmpsList($event)"
                                [externalSearchOptions]="{ resultsCount: employees.length, enabled: true }"
                                (onExternalSearch)="onSearchEmployeesChange($event)">
                            </sol-dropdown>
                            <sol-button class="ml-auto mr-4"
                                        (click)="removeEmpPermissions()"
                                        [variant]="'text'"
                                        [disabled]="selectedEmployeesList.size === 0">
                                <span cvLocalizedText langSection="Dashboard_Access" langKey="Remove">Remove All</span>
                            </sol-button>
                        </div>
                        <div [hidden]="selectedEmployeesList.size === 0">
                            <!-- Search -->
                            <sol-text-input [type]="'search'"
                                            autocomplete="off"
                                            [placeholder]="empSearchLocal"
                                            [(ngModel)]="employeeFilterValue"
                                            (ngModelChangeDebounced)="applyEmployeeFilter()"
                                            [ngModelChangeDebounceTime]="500"
                                            ng-trim="true">
                            </sol-text-input>
                        </div>
                        <div>
                            <!-- Employees AG Grid -->
                            <ag-grid-angular 
                                #dashboardAccessEmployeeGrid
                                *ngIf="employeeGridOptions !== null && activeTabIndex === 1 && selection === custom" 
                                class="ag-theme-balham flex-fill inner" 
                                [ngClass]="selectedEmployees.length === 0 ? 'ag-grid-no-search' : 'ag-grid-search'"
                                [gridOptions]="employeeGridOptions"
                                [rowHeight]="44">
                            </ag-grid-angular>
                        </div>
                    </div>
                </sol-tab>
            </sol-tabs>
        </div>
        </div>
    </sol-modal-body>

    <!-- Footer -->
    <sol-modal-footer>
        <div style="display: flex; justify-content: flex-end; column-gap: 10px;">
            <sol-button type="button"
                        variant="basic"
                        [size]="'medium'"
                        [disabled]="isSaving"
                        (click)="onCancelClicked()">
                <span cvLocalizedText [langSection]="'Common'" [langKey]="'Cancel_Button'">Cancel</span>
            </sol-button>
            <sol-button type="button"
                        [size]="'medium'"
                        [disabled]="(!shareDashboard && !hasCurrentShares && !isPublic) ||
            (selection === custom && numberOfChanges === 0) ||
            (shareDashboard && selection === allEmployees && isPublic) ||
            isSaving"
                        (click)="onSaveClicked()">
                <span cvLocalizedText [langSection]="'Common'" [langKey]="'Save_Button'">Save</span>
            </sol-button>
        </div>
    </sol-modal-footer>
</sol-modal>

<!-- Tab Title Templates -->
<!-- Without this the size of selected groups was not updating on the tabs -->
<ng-template #teamsTitle>
    <span>{{teamsLocal + ' (' + selectedTeamsList.size + ')'}}</span>
</ng-template>

<ng-template #employeesTitle>
    <span>{{employeesLocal + ' (' + selectedEmployeesList.size + ')'}}</span>
</ng-template>


